import S from "./index.module.scss";
import { FC } from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";

interface IDnaCard {
  item: string;
}

const DnaCard: FC<IDnaCard> = ({ item }) => {
  const t = useTranslations("about.dna");

  return (
    <div className={S.wrapper}>
      <Image src={`/images/about/dna/${item}.png`} width={200} height={200} alt={item} />
      <div className={S.textWrapper}>
        <p className={S.title}>{t(`${item}.title`)}</p> <p className={S.description}>{t(`${item}.description`)}</p>
      </div>
    </div>
  );
};

export default DnaCard;
